import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-week-off-management',
  templateUrl: './week-off-management.component.html',
  styleUrls: ['./week-off-management.component.css']
})
export class WeekOffManagementComponent implements OnInit {

  employees: any[] = [];
  selectedEmployee: any = null;

  weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  roster: any = {};

  years: number[] = [];
  weekNumbers: number[] = Array.from({ length: 52 }, (_, i) => i + 1);

  // selectedYear: number;
  // selectedWeek: number;

  selectedYear: number = new Date().getFullYear();
  selectedWeek: number = 1;
  weekStartDate: string = '';
  weekEndDate: string = '';
  skipAlert: boolean = false;
  currentUser: any;

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginService.getLocalSession('currentUser'));
    this.loadEmployees();

    const currentYear = new Date().getFullYear();
    this.selectedYear = currentYear;

    for (let y = currentYear - 5; y <= currentYear + 1; y++) {
      this.years.push(y);
    }

    this.selectedWeek = this.getCurrentWeek();

    // ⬇⬇ Call this to display week range immediately
    this.onWeekChange();
  }

  getCurrentWeek(): number {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const diff = now.getTime() - start.getTime();
    return Math.ceil((diff / 86400000 + start.getDay() + 1) / 7);
  }

  loadEmployees() {
    this.loginService.getEmployeesForAttendance(this.currentUser).subscribe((response: any) => {
      this.employees = response.employees || [];
    }, error => { alert('Network Error getEmployeesForAttendance API'); });
  }

  onEmployeeChange(event: any) {
    const empId = event.target.value;

    if (!empId) {
      this.selectedEmployee = null;
      return;
    }

    this.selectedEmployee = this.employees.find(e => e.id == empId);
    this.loadRoster();
  }

  loadRoster() {
    if (!this.selectedEmployee) return;

    const payload = {
      employee_id: this.selectedEmployee.id,
      year: this.selectedYear,
      week_no: this.selectedWeek,
      salon_id: this.currentUser.salon_id
    };

    this.roster = {};
    this.weekDays.forEach(day => {
      this.roster[day] = { type: '', in_time: '', out_time: '' };
    });

    this.loginService.getEmployeeRoster(payload).subscribe((res: any) => {
      if (!res || res.status === "error") {
        alert("No record found for this employee for selected week.");
        return;
      }
      this.roster = {};
      this.weekDays.forEach(day => {
        this.roster[day] = { type: '', in_time: '', out_time: '' };
      });
      if (res.roster && !Array.isArray(res.roster)) {
        // Copy and fix time format
        Object.keys(res.roster).forEach(day => {
          const d = res.roster[day];
          this.roster[day] = {
            type: d.type || '',
            in_time: d.in_time ? d.in_time.substring(0, 5) : '',
            out_time: d.out_time ? d.out_time.substring(0, 5) : ''
          };
        });
      }
    }, error => { alert('Network Error getEmployeeRoster API'); });
  }


  updateRoster(day: string, field: string, value: string) {

    if (!this.roster[day]) {
      this.roster[day] = { type: '', in_time: '', out_time: '' };
    }

    this.roster[day][field] = value;

    if (field === 'type' && value !== 'working') {
      this.roster[day].in_time = '';
      this.roster[day].out_time = '';
    }
  }

  saveRoster() {

    if (!this.selectedEmployee) {
      alert("Please select an employee.");
      return;
    }

    // validation...
    for (let day of this.weekDays) {
      const data = this.roster[day];
      if (!data.type) {
        alert(`Select Working / Week Off / Leave for ${day}`);
        return;
      }
      if (data.type === 'working' && (!data.in_time || !data.out_time)) {
        alert(`In & Out Time missing for ${day}`);
        return;
      }
    }

    // Calculate week range ONLY (do not reload roster)
    const range = this.getWeekDateRange(this.selectedYear, this.selectedWeek);
    this.weekStartDate = this.formatDate(range.start);
    this.weekEndDate = this.formatDate(range.end);

    const payload = {
      employee_id: this.selectedEmployee.id,
      year: this.selectedYear,
      week_no: this.selectedWeek,
      week_start: this.weekStartDate,
      week_end: this.weekEndDate,
      roster: this.roster,
      salon_id: this.currentUser.salon_id
    };

    // ⬅ prevent alert during reload
    this.skipAlert = true;

    this.loginService.saveEmployeeRoster(payload).subscribe(() => {
      alert("Roster saved successfully!");
      this.loadRoster(); // reload saved
    }, error => { alert('Network Error saveEmployeeRoster API'); });
  }


  getWeekDateRange(year: number, week: number) {

    const thursday = new Date(year, 0, 1 + (week - 1) * 7);

    const day = thursday.getDay(); // 0=Sun

    const diff = (day <= 4 ? 4 - day : 11 - day);
    thursday.setDate(thursday.getDate() + diff);

    const monday = new Date(thursday);
    monday.setDate(thursday.getDate() - 3);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return {
      start: this.formatYMD(monday),   // ⬅ FIXED
      end: this.formatYMD(sunday)      // ⬅ FIXED
    };
  }




  onWeekChange() {
    const range = this.getWeekDateRange(this.selectedYear, this.selectedWeek);

    this.weekStartDate = this.formatDate(range.start);
    this.weekEndDate = this.formatDate(range.end);

    // Auto reload roster if employee already selected
    if (this.selectedEmployee) {
      this.loadRoster();
    }
  }


  formatDate(date: string): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatYMD(date: Date): string {
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }


}



// WEBPACK FOOTER //
// ./src/app/week-off-management/week-off-management.component.ts